define('shoptheme/components/layout/lazyload',[
	"cartware/components/_base",
	"jquery",
	"jquery-lazyload",
	"cartware-slider"
], function(
	Component,
	$
) {
	var __slideshows = [];

	return Component.create({
		$init: function() {
			var self = this;

			this.initializeLazyload();
			this.initializeSlider();

			$(document).on('product/changeGallerySimple', _.debounce(function() {
				self.initializeSlider();
			}, 100));
		},

		initializeLazyload: function() {
			$("img").lazyload({
				load: function() {
					$(this).trigger("cartware/lazyload");
				}
			});
		},

		initializeSlider: function() {
			$(".cartware-slider").each(function() {
				if (__slideshows.indexOf(this) < 0) {
					var slideshow = $(this);

					slideshow.find("img").lazyload();

					__slideshows.push(this);
				}
			});
		}
	});
});
